import React from "react";
import { useState, useEffect } from "react";
import '../Styles/CamperTypeSelection.scss';
import DataAccessHelper from "../Helper/DataAccessHelper";
import DateHelpers from "../Helper/DateHelpers";
import { CombinationPageOptions } from "../Constants/RegistrationPageOptions";

function CamperTypeSelection({ camperType, setCamperType, week, groupJoined, promoCode, setPromoCode, 
   selectedPage, setSelectedPage, fastTrack, setFastTrack, guestId, isSignatureRequired, setIsSignatureRequired, currentRegistrant, personalInformation }) {

   const [camperTypeError, setCamperTypeError] = useState(false)
   const [invalidGroupLeaderError, setInvalidGroupLeaderError] = useState(false)
   const [invalidCCGLAgeError, setInvalidCCGLAgeError] = useState(false)
   const [invalidCamperAgeError, setInvalidCamperAgeError] = useState(false)
   function handleCamperType(camperType) {
      setCamperType(camperType)

      // Clear errors
      setCamperTypeError(false)
      setInvalidGroupLeaderError(false)
      setInvalidCCGLAgeError(false)
      setInvalidCamperAgeError(false)
      setPromoCode({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, promoId: null })
   }

   async function handleNext() {

      console.log("CamperType", camperType)
      let camperBirthdate = personalInformation.birthDate;
      console.log(camperBirthdate, "Here is the camper birthdate in Camper Type Selection!")
      const guestAge = await DateHelpers.determineCamperAgeInYears(camperBirthdate)
      if (camperType == 'Select Camper Type') {
         setCamperTypeError(true)
      }
      else if ((groupJoined == null && camperType === 'Group Leader')) {
         // The only campers attending with a group can be of type group leader
         setInvalidGroupLeaderError(true)
      }
      else if (camperType === 'Church Counselor' || camperType == 'Group Leader') {
         const isCCValid = DataAccessHelper.DetermineIfCCOrGLIsValidAgeForGuestSelecting(guestAge)
         if (!isCCValid) {
            setInvalidCCGLAgeError(true)
         }
         else {
            // Signature not required, for church counselors or group leaders
            setIsSignatureRequired(false)
            setSelectedPage(CombinationPageOptions.Review)
         }
      }
      else {
         const isCamperValid = DataAccessHelper.DetermineIfCamperIsValidAgeForGuestSelecting(week.camp_type, guestAge)
         if (!isCamperValid) {
            setInvalidCamperAgeError(true)
         }
         else {
            if(guestAge >= 18){
               setIsSignatureRequired(false)
               setSelectedPage(CombinationPageOptions.Review)
            }
            else{
               setIsSignatureRequired(true)
               setSelectedPage(CombinationPageOptions.Disclaimer)
            }            
         }
      }
   }

   useEffect(() => {
      console.log("current Registrant in Camper Type Selection", personalInformation)
      let birthDate = personalInformation.birthDate
      console.log(birthDate)
      handleCamperType(camperType)
    }, [])

   return (
         <div className="camperTypeContainer">
            <div className="camperTypeHeading">
               Camper Type Selection
            </div>
            <form>
               <div className="selectCamperType">
                  <label>Select Camper Type: &nbsp;</label>
                  <select
                     value={camperType}
                     onChange={(e) => handleCamperType(e.target.value)}
                  >
                     <option value="Select Camper Type">Select Camper Type </option>
                     <option value="Camper">Camper</option>
                     <option value="Church Counselor">Church Counselor</option>
                     <option value="Group Leader">Group Leader</option>
                  </select>
               </div>

               <div className="registrationCards">
                  <div className="groupLeaderCard">
                     <div className="groupLeaderCardContent">
                        <h1 className="groupLeaderCardHeading">Camper</h1>
                        <p className="groupLeaderCardText">
                           Campers are children and teens<br></br>
                           who meet the age requirements <br></br>
                           of the specified camp <br></br>
                        </p>
                     </div>
                  </div>


                  <div className="counselorCard">
                     <div className="counselorCardContent">
                        <h1 className="counselorCardHeading">Church Counselor</h1>
                        <p className="counselorCardText">
                           Church counselors are adults from the <br></br>
                           camper's local church who lead campers<br></br>
                           in their daily activities
                        </p>
                     </div>
                  </div>


                  <div className="camperCard">
                     <div className="camperCardContent">
                        <h1 className="camperHeading">Group Leader</h1>
                        <p className="camperText">
                           Group Leaders hold the <br></br>
                           responsibility for the campers<br></br>
                           and church counselors in their group
                        </p>
                     </div>
                  </div>
               </div>


            </form>
            {camperTypeError == true &&
               <div className="camperTypeError">
                  Please select a valid camper type.
               </div>
            }
            {invalidGroupLeaderError == true &&
               <div className="invalidCCOrGroupLeaderError">
                  You must join a group to be a church counselor or group leader.
               </div>
            }
            {invalidCCGLAgeError === true &&
               <div className="invalidCCOrGLAge">
                  Invalid age for church counselor or group leader.
               </div>
            }
            {invalidCamperAgeError === true &&
               <div className="invalidCamperAge">
                  Invalid age for camper.
               </div>
            }
            <div className="camperTypeSelectionButtons">
               <div className="CamperTypeSelectionPreviousButton">
                  <button onClick={() => setSelectedPage(CombinationPageOptions.JoinGroup)}>
                     Previous
                  </button>
               </div>
               <div className="CamperTypeSelectionNextButton">
                  <button onClick={(event) => handleNext()}>
                     Next
                  </button>
               </div>
            </div>
         </div>
   )
}

export default CamperTypeSelection;
